import React from 'react';
import PropTypes from 'prop-types';
import SkintoneImg from '../components/SkintoneImg';
import { CSSTransitionGroup } from 'react-transition-group';
import '../index.css';

function Skintone(props) {
  return (
    <CSSTransitionGroup
    className="container"
    component="div"
    transitionName="fade"
    transitionEnterTimeout={2000}
    transitionLeaveTimeout={1500}
    transitionAppear
    transitionAppearTimeout={1500}
    >
    <div className="container-btn skintone-container">
        <div className="row questionmargin">
            <div className="col-4 col-md-3 question-circle__col">
                <span className="question-circle text-center">Q5</span>
            </div>
            <div className="col-8 col-md-9">
                <h2 className="question-heading">
                    Select the model closest to your skin tone
                </h2>
            </div>
        </div>
        <div className="skintone-shades">
            <div className="skintone-shade">
                <div className="skintone-rowHeadingBackground skintone-mobile text-center">
                    <h4 className="skintone-rowHeadingText">Light</h4>
                </div>

                <div className="row">
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/px1zR74.jpg" value="cream-beige" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/nxolXk1.jpg" value="tender-beige" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/HJQcDUQ.jpg" value="almond" onModelSelected={ props.onModelSelected } />
                    </div>
                </div>

                <div className="skintone-rowHeadingBackground skintone-desktop text-center">
                    <h4 className="skintone-rowHeadingText">Light</h4>
                </div>
            </div>

            <div className="skintone-shade">
                <div className="skintone-rowHeadingBackground skintone-mobile text-center">
                    <h4 className="skintone-rowHeadingText">Medium &amp; Tan</h4>
                </div>

                <div className="row">
                    <div className="col-md-3 model-img">
                        <SkintoneImg src="https://i.imgur.com/9H8wKks.jpg" value="sandy-beige" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-3 model-img">
                        <SkintoneImg src="https://i.imgur.com/wPZX5RV.jpg" value="golden-honey" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-3 model-img">
                        <SkintoneImg src="https://i.imgur.com/l9ebV7H.jpg" value="golden-beige" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-3 model-img">
                        <SkintoneImg src="https://i.imgur.com/lxO4BR0.jpg" value="brown-sugar" onModelSelected={ props.onModelSelected } />
                    </div>
                </div>

                <div className="skintone-rowHeadingBackground skintone-desktop text-center">
                    <h4 className="skintone-rowHeadingText">Medium &amp; Tan</h4>
                </div>
            </div>

            <div className="skintone-shade">
                <div className="skintone-rowHeadingBackground skintone-mobile text-center">
                    <h4 className="skintone-rowHeadingText">Deep</h4>
                </div>

                <div className="row">
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/tqa5cgz.jpg" value="rich-bronze" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/7P3Ztza.jpg" value="dark-coffee" onModelSelected={ props.onModelSelected } />
                    </div>
                    <div className="col-md-4 model-img">
                        <SkintoneImg src="https://i.imgur.com/087pHUi.jpg" value="cocoa" onModelSelected={ props.onModelSelected } />
                    </div>
                </div>

                <div className="skintone-rowHeadingBackground skintone-desktop text-center">
                    <h4 className="skintone-rowHeadingText">Deep</h4>
                </div>
            </div>
        </div>
    </div>
    </CSSTransitionGroup>
  );
}

Skintone.propTypes = {
    onContinueSelected: PropTypes.func.isRequired,
    onBackSelected: PropTypes.func.isRequired,
    onModelSelected: PropTypes.func.isRequired
};

export default Skintone;